import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-45a834a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "relative chat flex flex-col justify-between w-screen sm:w-auto"
};
const _hoisted_2 = {
  class: "flex flex-col w-full items-baseline px-2"
};
const _hoisted_3 = {
  class: "flex-none bg-white py-3"
};
const _hoisted_4 = {
  class: "rounded w-10/12 mx-auto text-input flex-1 flex border border-indigo-400 items-center"
};
const _hoisted_5 = {
  key: 0,
  class: "image-preview"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "button-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_welcome = _resolveComponent("a-welcome");
  const _component_ai_message = _resolveComponent("ai-message");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_Phone = _resolveComponent("Phone");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_Promotion = _resolveComponent("Promotion");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
    ref: "scrollbar"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["box-border flex p-2 w-full h-full bg-gray-100 box-border overflow-auto", {
        'bg-white': _ctx.history.length > 0
      }])
    }, [_withDirectives(_createVNode(_component_a_welcome, {
      modelValue: _ctx.text,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.text = $event)
    }, null, 8, ["modelValue"]), [[_vShow, _ctx.history.length === 0]]), _withDirectives(_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
      return _openBlock(), _createBlock(_component_ai_message, {
        key: index,
        str: item.message,
        "is-me": item.user !== 'AI'
      }, null, 8, ["str", "is-me"]);
    }), 128)), _ctx.writing ? (_openBlock(), _createBlock(_component_ai_message, {
      key: 0,
      writing: _ctx.writing,
      str: _ctx.answer,
      "is-me": false
    }, null, 8, ["writing", "str"])) : _createCommentVNode("", true)], 512), [[_vShow, _ctx.history.length > 0]])], 2)]),
    _: 1
  }, 512), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_ctx.img_url ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
    src: _ctx.img_url,
    alt: "Uploaded Image"
  }, null, 8, _hoisted_6), _createElementVNode("button", {
    class: "delete-button",
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.removeImage && _ctx.removeImage(...args))
  }, "×")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
    id: "voice-input",
    class: "custom-button",
    onClick: _ctx.onVoiceInput
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Phone)]),
      _: 1
    }), _createTextVNode(" " + _toDisplayString(_ctx.buttonLabel), 1)]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("input", {
    type: "file",
    id: "file",
    ref: "fileInput",
    style: {
      "display": "none"
    },
    onChange: _cache[2] || (_cache[2] = (...args) => _ctx.onFileSelected && _ctx.onFileSelected(...args))
  }, null, 544), _createVNode(_component_el_input, {
    class: "py-1",
    modelValue: _ctx.text,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.text = $event),
    autosize: {
      minRows: 2,
      maxRows: 8
    },
    resize: "none",
    type: "textarea",
    placeholder: "输入您的问题 (shift+enter 换行)",
    onKeydown: _withKeys(_ctx.handleEnterKeyDown, ["enter"]),
    onKeyup: _withKeys(_ctx.handleEnterKeyUp, ["enter"])
  }, null, 8, ["modelValue", "onKeydown", "onKeyup"]), _createVNode(_component_el_button, {
    disabled: !_ctx.text,
    loading: _ctx.writing,
    onClick: _ctx.send,
    color: "rgb(99 102 241)",
    class: "self-end rounded-md mb-1 mr-1 border-none cursor-pointer h-8 bg-indigo-500/10 w-20 text-indigo-500 p-2 flex justify-center items-center hover:bg-indigo-500/20 hover:text-indigo-500"
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Promotion)]),
      _: 1
    }, 512), [[_vShow, !_ctx.writing]])]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"])])])])), [[_directive_loading, _ctx.historyLoading]]);
}